import React from 'react';

export type EnterpriseStatusTone =
  | 'draft'
  | 'published'
  | 'standard'
  | 'active'
  | 'risk'
  | 'completed'
  | 'archived'
  | 'warning';

interface EnterpriseStatusBadgeProps {
  label: string;
  tone: EnterpriseStatusTone;
  className?: string;
}

const toneClassMap: Record<EnterpriseStatusTone, string> = {
  draft: 'enterprise-status-draft',
  published: 'enterprise-status-published',
  standard: 'enterprise-status-standard',
  active: 'enterprise-status-active',
  risk: 'enterprise-status-risk',
  completed: 'enterprise-status-completed',
  archived: 'enterprise-status-archived',
  warning: 'enterprise-status-warning',
};

export function EnterpriseStatusBadge({
  label,
  tone,
  className = '',
}: EnterpriseStatusBadgeProps) {
  return (
    <span className={`enterprise-status-badge ${toneClassMap[tone]} ${className}`.trim()}>
      {label}
    </span>
  );
}

export default EnterpriseStatusBadge;
